import React from 'react'
import { config } from 'config'
import { Link } from 'react-router'
import { prefixLink } from 'gatsby-helpers'
import Helmet from 'react-helmet'
import { Container, Grid, Breakpoint, Span } from 'react-responsive-grid'
import { rhythm } from '../utils/typography'
import { Scrollspy } from 'react-scrollspy'
import ThreejsBackdrop from 'components/ThreejsBackdrop'
import PortfolioSection from 'components/PortfolioSection'
import AwardsSection from 'components/AwardsSection'
import styles from './index.module.scss'
import profilePic from 'components/profile-pic.jpg'
import Scroll from 'react-scroll'

import cn from 'classnames';

// Data
import works from 'data/works'
import workCategories from 'data/work-categories'
import awards from 'data/awards'
import volunteeringWorks from 'data/volunteering-works'

export default class Index extends React.Component {

  constructor() {
    super();
    this.state = {
      isBrowser: false,
      showContactModal: false
    };
  }

  componentDidMount() {
    this.setState({isBrowser: true});
  }

  renderScrollSpy() {
    return <div className="scrollspy">
      <Scrollspy items={ ['section-hello', 'section-works', 'section-awards'] } currentClassName="is-current" offset={-250}>
        <li><a href="#section-hello">HELLO</a></li>
        <li><a href="#section-works">WORKS</a></li>
        <li><a href="#section-awards">AWARDS</a></li>
      </Scrollspy>
    </div>
  }

  render () {
    let ScrollElement = Scroll.Element;
    let ScrollLink = Scroll.Link;
    
    return (
      <div>
        <Helmet
          title={config.siteTitle}
          meta={[
            {"name": "description", "content": "Sample"},
            {"name": "keywords", "content": "sample, something"},
          ]}
        />
        <div className={styles.hero} id="section-hello">
          <ThreejsBackdrop/>
          <div className={styles.heroTitle}>
            <p>Hello, I'm</p>
            <h1>SORAVIS<br/>PRAKKAMAKUL.</h1>
            <div className={styles.heroText}>
              <p>
                As an engineer/designer hybrid, I investigate design questions through the creation of functional, living, and breathing prototypes. My experiments range from a <a href="https://facemod-music.firebaseapp.com" target="_blank"><span className="text-hilighted">guitar effect box controlled by facial expressions</span></a> to a <a href="https://bstream.now.sh/" target="_blank"><span className="text-hilighted">pay-per-second music streaming on the blockchain.</span></a>
              </p><br />
              <p>
                I’m currently pursuing a masters degree at <a href="https://www.ischool.berkeley.edu/people/soravis-prakkamakul"><span className="text-hilighted">UC Berkeley, I-School</span></a>. 
                Before that, I co-founded <a href="http://runnables.co.th"><span className="text-hilighted">Runnables</span></a>, an app development studio based in Bangkok, Thailand.
              </p>
            </div>
            <br />
            <Grid columns={12} className="navbar">
              <Breakpoint minWidth={600} widthMethod="componentWidth">
                <ScrollLink className="btn btn-malibu hvr-grow"
                  to="works"
                  smooth={true}
                  duration={500}
                  style={{
                    color: 'white',
                    textDecoration: 'none',
                  }}
                >
                  VIEW WORKS
                </ScrollLink>
                {/*
                <span className="large-space"> </span>
                <Link
                  className="btn btn-narrow hvr-grow"
                  onClick={() => {this.showContactModal()}}
                  smooth={true}
                  duration={500}
                  style={{
                    color: 'white',
                    textDecoration: 'none',
                  }}
                >
                  CONTACT
                </Link>
                */}
                <span className="large-space"> </span>
                or 
                <span className="large-space"> </span>
                <Link
                  className="btn btn-narrow hvr-grow"
                  to="/about/"
                  smooth={true}
                  duration={500}
                  style={{
                    color: 'white',
                    textDecoration: 'none',
                  }}
                >
                  MORE ABOUT ME
                </Link>
              </Breakpoint>
              <Breakpoint maxWidth={600} widthMethod="componentWidth">
                <ScrollLink className="btn btn-malibu hvr-grow"
                  to="works"
                  smooth={true}
                  duration={500}
                  style={{
                    color: 'white',
                    textDecoration: 'none',
                  }}
                >
                  VIEW WORKS
                </ScrollLink>
              </Breakpoint>
            </Grid>

            
          </div>
        </div>
        <Container
            style={{
              maxWidth: 1170,
              paddingTop: 0,
              padding: `${rhythm(1)} ${rhythm(3/4)}`,
            }}
          >
          <ScrollElement name="works" className="element" id="section-works">
            <div className="section-header">
              <h2>Works</h2>
              <p>Selected Projects</p>
            </div>

            <PortfolioSection works={works} workCategories={workCategories} />
          </ScrollElement>
        </Container>

      </div>
    )
  }
}



/** WEBPACK FOOTER **
 ** ./index.js
 **/